export enum MonthlyQuotaKeys {
    InitialMinutesUsed = "InitialMinutesUsed",
    AddMinutesUsedSucceeded = "AddMinutesUsedSucceeded",
    MinutesUsedAdded = "MinutesUsedAdded"
};